<script>
    let clsPrefix = "sui-result";
    export let status = "success";
    export let desc = "";
    export let title = "";
    const statusMap = {
        success: "操作成功",
        warn: "警告提示",
        progress: "处理中",
    };
</script>

<div class={`${clsPrefix} ${$$props.class || ""}`}>
    <div class={`${clsPrefix}-icon`}>
        {#if status === "success"}
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="success"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="12" cy="12" r="12" fill="currentColor" />
                <path
                    d="M7.41174 12.8734L10.8581 15.8779L17.0665 9.17627"
                    stroke="white"
                    stroke-width="2.82353"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        {/if}
        {#if status === "warn"}
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="warn"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="currentColor"
                />
                <path
                    d="M12.0001 14.1172C11.2558 14.1172 10.6461 13.5824 10.5922 12.9041L10.5883 12.8063L10.5883 6.25164C10.5883 5.52764 11.2204 4.94072 12.0001 4.94072C12.7444 4.94072 13.3541 5.47549 13.408 6.15381L13.4119 6.25164L13.4119 12.8063C13.4119 13.5303 12.7798 14.1172 12.0001 14.1172Z"
                    fill="white"
                />
                <circle
                    cx="12.0001"
                    cy="17.294"
                    r="1.76471"
                    transform="rotate(90 12.0001 17.294)"
                    fill="white"
                />
            </svg>
        {/if}
        {#if status === "progress"}
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="progress"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="12" cy="12" r="12" fill="currentColor" />
                <path
                    d="M11.3165 7.93248L11.3165 12.9185L16.6382 12.9185"
                    stroke="white"
                    stroke-width="2.82353"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        {/if}
    </div>
    <h2 class={`${clsPrefix}-desc`}>{title || statusMap[status]}</h2>
    {#if desc}
        <div class={`${clsPrefix}-info`}>
            <span>{desc}</span>
        </div>
    {/if}
</div>

<style lang="less">
    @import "./result.less";
</style>
